import { render } from "./HomeEventCard.vue?vue&type=template&id=31cf04fe"
import script from "./HomeEventCard.vue?vue&type=script&lang=js"
export * from "./HomeEventCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__